

import router from "@/router";




import admin from '@/container/gold'



router.addRoute({
    name: $t('message.homepage') ,
    path: '/', 
    component: gold ,
    meta: {
        requiresAuth: true,
        //title: 'message.dashboard1',
        //breadcrumb: 'message.dashboardDashboard1'
    }
})
router.addRoute({ name: 'login' ,path: '/session/Login/', component: Login })

//$t('message.homepage')

export default router